/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { HTMLProps, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldInputProps, FieldMetaProps } from 'formik';
import * as Yup from 'yup';
import { Col, Row } from 'antd';

import { Text } from '~/components/Typo/Typo';
import { FontWeight, TextVariants } from '~/theme/constants';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
// import CountrySelect from '~/components/forms/CountrySelect/CountrySelect';
import PhoneInputField from '~/components/fields/PhoneInputField/PhoneInputField';
import { MeansOfPayment } from '~/entities/schemas/meansOfPayment';
import mtnMoneyLogo from '~/assets/images/mtnmoney-logo.png';
import orangeMoneyLogo from '~/assets/images/orangemoney-logo.png';
import Loader from '~/components/Loader/Loader';
import { AvailableCountry } from '~/entities/schemas/availableCountry';
import { ActiveOperator } from '~/entities/schemas/activeOperator';
import Card from '~/components/Card/Card';
import Image from '~/components/Image/Image';

import './MobilePaymentForm.scss';

export interface MobilePaymentFormProps extends HTMLProps<HTMLFormElement> {
  // handleSubmit: (values: any, payment: MeansOfPayment) => void;
  selectedItem?: number;
  paymentInfos?: GetPaymentResponse;
  loading?: boolean;
  getFieldProps: (name: string) => FieldInputProps<any>;
  getFieldMeta: (name: string) => FieldMetaProps<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setFieldValue: any;
  valuesMobile: any;
  gettingCountries: boolean;
  countries: AvailableCountry[];
  countriesRefact: string[];
  setSelectedAvailableCountry: any;
  setPhoneNumber: any;
  setDialCode: any;
  isMobile?: boolean;
}

const MobilePaymentForm: React.FC<MobilePaymentFormProps> = ({
  paymentInfos,
  loading,
  getFieldProps,
  getFieldMeta,
  handleChange,
  setFieldValue,
  valuesMobile,
  gettingCountries,
  countries,
  countriesRefact,
  setSelectedAvailableCountry,
  setPhoneNumber,
  setDialCode,
  isMobile,
}) => {
  const { t } = useTranslation();

  const [phone, setPhone] = useState<string>('');
  const [meanOfPayment, setMeanOfPayment] = useState<MeansOfPayment>();
  const [meanOfPayments, setMeanOfPayments] = useState<MeansOfPayment[]>([]);
  const [loader, setLoader] = useState<boolean>(true);
  const [operators, setOperators] = useState<ActiveOperator[]>([]);
  const [availableCountry, setAvailableCountry] = useState<AvailableCountry>();
  // const [countriesRefact, setCountriesRefact] = useState<string[]>([]);
  // const [refactoring, setRefactoring] = useState<boolean>(false);

  const handleChangePhoneNumber = useCallback((newPhone: string, data: any, event: any, formattedValue: any) => {
    const countryCode = data?.countryCode || '';
    const activeCountry = countries.find(e => e.countrycode.toLowerCase() === countryCode.toLowerCase());

    setSelectedAvailableCountry(activeCountry);
    setOperators(activeCountry?.operators as ActiveOperator[]);
    setAvailableCountry(activeCountry);
    setPhone(newPhone);
    setDialCode(data.dialCode);
    setFieldValue('phoneNumber', newPhone);
    setPhoneNumber(newPhone);
    setDialCode(data.dialCode);
  }, []);

  const validate = Yup.object({
    // phone: Yup.string().required(t('home:cardPaymentForm:phoneRequired')),
    // fullName: Yup.string().required(t('home:cardPaymentForm:fullNameRequired')),
  });

  const setDefaultOperator = useCallback(() => {
    if (!countries[0]) {
      setOperators([]);
      return;
    }

    setSelectedAvailableCountry(countries[0]);
    setAvailableCountry(countries[0]);
    setOperators(countries[0].operators);
  }, []);

  const initData = useCallback(() => {
    setLoader(true);
    const mobileMeansOfPayment = paymentInfos?.data.meansOfPayment.filter(
      d => d.type === 'MOBILE_MONEY',
    ) as MeansOfPayment[];
    setMeanOfPayments(mobileMeansOfPayment);
    if (paymentInfos !== undefined) {
      setLoader(false);
    }
  }, [paymentInfos]);

  // const initCountries = useCallback(() => {
  //   setRefactoring(true);
  //   const finalCountries = [];
  //   for (const c of countries) {
  //     finalCountries.push(c.countrycode.toLowerCase());
  //   }
  //   console.log('finalCountries', finalCountries);
  //   setCountriesRefact(finalCountries);
  //   setRefactoring(false);
  // }, [countries]);

  const getImageOnCodeBased = useCallback((code: string): string => {
    switch (code) {
      case 'MOMO.CM':
        return mtnMoneyLogo;
      case 'OM.CM':
        return orangeMoneyLogo;
      default:
        return ''; // TODO: add a default image
    }
  }, []);

  const isCountryCodeAllowed = (countryCode: string) =>
    [paymentInfos?.data.customerCountry ? paymentInfos?.data.customerCountry.toLowerCase() : 'cm'].includes(
      countryCode,
    );

  useEffect(() => {
    // initCountries();
    initData();
    setDefaultOperator();
  }, [paymentInfos]);
  return (
    <div className="mobile-payment-form">
      <div className="caption-wrapper">
        <div className="caption-container">
          <Text className="caption" weight={FontWeight.BOLD}>
            {t('home:mobilePaymentForm:availableOperators')}
          </Text>
        </div>
        {isMobile && loading && (
          <div className="sub-caption-container">
            <Text className="caption" weight={FontWeight.NORMAL}>
              {t('home:mobilePaymentForm:yourPaymentIsBeingProcessed')}
            </Text>
          </div>
        )}
      </div>
      <div className="mean-of-payment-wrapper">
        <Row justify="center">
          {operators.length > 0 ? (
            operators.map((e, i) => (
              <Col lg={3} md={3} sm={6} xs={6}>
                {/* <Card key={i} className="only-payment"> */}
                {/* {e.network} */}
                <Image className="logo-wrapper" imgClassName="logo" image={e.logo_url} rounded />
                {/* </Card> */}
              </Col>
            ))
          ) : (
            <Text>{t('home:mobilePaymentForm:noOperatorsAreAvailable')}</Text>
          )}
        </Row>
      </div>
      <div></div>
      {/* <div className="subtitle-wrapper">
        <Text className="subtitle" size="p" weight={FontWeight.BOLD}>
          Moyens de paiement disponibles
        </Text>
      </div> */}
      {/* {loader ? (
        <Row justify="center">
          <Loader />
        </Row>
      ) : (
        <Row justify="center">
          {meanOfPayments?.map((e, i) => (
            <Col key={i} lg={10} xs={8} sm={10} md={10}>
              <MobilePaymentCard
                onClick={() => {
                  setMeanOfPayment(e);
                }}
                active={e.id === meanOfPayment?.id}
                key={i.toString()}
                label={e.code}
                image={getImageOnCodeBased(e.code)}
              />
            </Col>
          ))}
        </Row>
      )} */}
      <div className="mobile-form-wrapper">
        {gettingCountries ? (
          <Row justify="center">
            <Loader />
          </Row>
        ) : (
          <Row justify="center">
            <Col lg={12}>
              <PhoneInputField
                value={valuesMobile.phoneNumber}
                onChange={(newPhone, data, event, formattedValue) =>
                  handleChangePhoneNumber(newPhone, data, event, formattedValue)
                }
                placeholder={t('home:cardPaymentForm:phoneNumber')}
                disabled={loading}
                // paymentInfos?.data.customerCountry ? paymentInfos?.data.customerCountry.toLowerCase() :
                initialCountry={countriesRefact[0] ?? ''}
                // paymentInfos?.data.customerCountry ? paymentInfos?.data.customerCountry.toLowerCase() :
                countries={countriesRefact}
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default MobilePaymentForm;
